export const Roles = {
  MASTER_ADMIN : "MASTER_ADMIN",
  SUPER_ADMIN: "SUPER_ADMIN",
  ADMIN : "ADMIN",
  NORMAL_USER: "USER",
};